import React from 'react';
import { Body5 } from '@ui';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper } from '@flow/styles';

export const InputParameter = ({ data, value, onRemove, onChange }) => {
  const { keyName, label } = data;

  const handleChange = (e) => {
    const value = e.target.value;
    onChange(keyName, value);
  };
  const handleRemoveClick = () => onRemove(keyName);

  return (
    <AgentFlowParameterWrapper>
      <AgentFlowParameterLabelWrapper>
        <Body5>{label}:</Body5>
      </AgentFlowParameterLabelWrapper>
      <input value={value} onChange={handleChange} />
      <NodeParameterRemoveButton onClick={handleRemoveClick} />
    </AgentFlowParameterWrapper>
  );
};
